import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { FieldContextMenuComponent } from './field-context-menu.component';

@NgModule({
  imports: [CommonModule, BsDropdownModule],
  declarations: [FieldContextMenuComponent],
  exports: [FieldContextMenuComponent],
})
export class FieldContextMenuModule {}
